import { Model as e } from "../../../model.js";
class i extends e {
  constructor(a) {
    super(), this.accBalance = a.accBalance, this.balance = a.balance, this.code = a.code, this.expirationDate = a.expirationDate, this.maxBalance = a.maxBalance, this.subStatus = a.subStatus, this.stampCard = a.stampCard, this.user = a.user;
  }
}
export {
  i as StampAccountModel
};
//# sourceMappingURL=stampAccount.model.js.map
